// extracted by mini-css-extract-plugin
export default {"header":"header---iby47","divider":"divider---HgHZp","button":"button---kDQ2z","avatar":"avatar---pYbHE","button__label":"button__label---DiijC"};